// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"77":"AboutView","94":"Login","251":"HelloWorld","333":"Layout","810":"NotFound"}[chunkId] + "." + {"77":"45dcb039","94":"48d5c9d8","251":"94fda83f","333":"c26f5b77","810":"d293ed1c"}[chunkId] + ".js";
};